import { NewsList } from "@/components/News/NewsList";
import { getBundesligaNews, getSidebar } from "@/data/news";
import { News } from "@/models/types";
import { PostOrPage } from "@tryghost/content-api";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../../components/Footer";
import { StaticGhostPage } from "../../../components/StaticGhostPage";
import { Nav } from "../../../components/common/FrontendNav";
import getPage from "../../../news/getPage";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const page = await getPage(
    context.locale === "de"
      ? "64954b590f1ea200015acda0"
      : "64cb616d193d060001d02e2f",
  );

  const { news } = await getBundesligaNews({
    locale: context.locale,
  });

  const sidebar = await getSidebar(context.locale);
  return {
    props: {
      page,
      news,
      sidebar,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface NewsPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
  news: News[];
}
export default function NewsPage({ page, news, sidebar }: NewsPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t(
          "Title_TTBL_Finals",
        )}`}</title>
      </Head>
      <div>
        <Nav />
        <StaticGhostPage page={page} sidebar={sidebar} />
        {news.length > 0 && (
          <div className="container container_py">
            <NewsList news={news} title="Bundesliga News" type="bundesliga" />
          </div>
        )}
        <Footer />
      </div>
    </>
  );
}
